import { ICenter } from '../center';
import { IWatrRequest } from '../watr-request';

export interface IDonorShieldDirect {
    id: number;
    centerId: number;
    center: ICenter;
    surgeryDate: string;
    isBilled: boolean;
    isAdvancedReimbursementInvitee?: boolean;
    donorRegistrationId: number;
    donorUnosId: string;
    donorAlias: string;
    donorEmail: string;
    donorAboType: string;
    donorGender: string;
    donorName: string;
    donorAddressLine1: string;
    donorAddressLine2: string;
    donorCity: string;
    donorState: string;
    donorPostalCode: string;
    donorPhoneNumber: string;
    donorBirthdate: string;
    donorAge: number;
    donorOrgan: string;
    organType: number;
    recipientAlias: string;
    recipientEmail: string;
    recipientFirstName: string;
    recipientLastName: string;
    recipientAboType: string;
    recipientUnosCpra: string;
    recipientGender: string;
    recipientBirthdate: string;
    recipientAge: number;
    recipientPrimaryInsurance: string;
    recipientSecondaryInsurance: string;
    hasStreamlinedSerologyOrder: boolean;
    watrRequest?: IWatrRequest
}
